function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var host = "https://cdn.contentful.com";
var CONTENTFUL_KEY = "CONTENTFUL_KEY";
var helper = function(item, entryDict) {
    var newItem = {};
    if (item.sys.id in entryDict) {
        newItem = entryDict[item.sys.id];
    } else {
        newItem = item;
    }
    if (newItem.fields.components) {
        var originalComponents = newItem.fields.components;
        var newComponents = [];
        originalComponents.forEach(function(component) {
            newComponents.push(helper(component, entryDict));
        });
        newItem.fields = _extends({}, newItem.fields, {
            components: newComponents
        });
    }
    return newItem;
};
var contructEntryDict = function(entries) {
    var dict = {};
    entries.forEach(function(entry) {
        dict[entry.sys.id] = entry;
    });
    return dict;
};
var reconstructData = function(items, entries) {
    var newItems = [];
    var entriesDict = contructEntryDict(entries);
    items.forEach(function(item) {
        newItems.push(helper(item, entriesDict));
    });
    return newItems;
};
var getContentfulCache = function(key) {
    var itemStr = sessionStorage.getItem(key);
    if (!itemStr) {
        return null;
    }
    var item = JSON.parse(itemStr);
    var now = new Date();
    if (now.getTime() > item.expiry) {
        sessionStorage.removeItem(key);
        return null;
    }
    return item.value;
};
var setContentfulCache = function(key, value, ttl) {
    if (ttl === void 0) ttl = 60 * 60 * 1000;
    var now = new Date();
    var item = {
        value: value,
        expiry: now.getTime() + ttl
    };
    sessionStorage.setItem(key, JSON.stringify(item));
};
var getRemoteData = /*#__PURE__*/ _async_to_generator(function(param) {
    var spaceID, entryID, environmentID, accessToken, key, cachedData, returnItems, response, data;
    return _ts_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                spaceID = param.spaceID, entryID = param.entryID, environmentID = param.environmentID, accessToken = param.accessToken;
                key = CONTENTFUL_KEY + spaceID + environmentID + entryID;
                cachedData = getContentfulCache(key);
                if (cachedData) {
                    return [
                        2,
                        cachedData
                    ];
                }
                return [
                    4,
                    fetch(host + "/spaces/" + spaceID + "/environments/" + environmentID + "/entries/?include=10&locale=en-US&sys.id=" + entryID + "&access_token=" + accessToken)
                ];
            case 1:
                response = _state.sent();
                return [
                    4,
                    response.json()
                ];
            case 2:
                data = _state.sent();
                if (data.includes.Entry) {
                    returnItems = reconstructData(data.items, data.includes.Entry);
                } else {
                    returnItems = data.items;
                }
                setContentfulCache(key, returnItems);
                return [
                    2,
                    returnItems
                ];
        }
    });
});
export default getRemoteData;

//# sourceMappingURL=getRemoteData.js.map